export default __webpack_public_path__ + "locales/tr/SharingPanel.json?hash=4e1a56edde8f0933ce5da7b0dd504e29";